
<div class="w-full h-full flex flex-col gap-2 overflow-y-auto">
    <div class="w-full flex items-center justify-between">
        <button class="w-10 h-10 flex items-center justify-center hover:text-nside-orange-400"
            (click)="$event.preventDefault(); onBack();"
        >
            <lucide-icon [img]="icons.ArrowLeft" size="32"></lucide-icon>
        </button>
        <div class="flex items-center justify-center gap-2 text-nside-orange-400">
            <h2 class="oswald-font text-2xl">Case {{ this.currentCaseId }}</h2>
            <div class="relative flex items-center justify-center">
                <button 
                    data-tooltip-target="tooltip-student-info"
                    data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-8 h-8 shrink-0"
                    (click)="$event.preventDefault(); handleOpenModal('student info');"
                >
                    <lucide-icon [img]="icons.FileText"></lucide-icon>
                </button>
            
                <div id="tooltip-student-info" 
                     role="tooltip"
                     class="absolute z-30 invisible inline-block whitespace-nowrap px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    Student Info
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full flex flex-col items-center justify-center gap-2">
        <h2 class="w-full oswald-font text-2xl">
            Behavioral Threat Assessment Screening
        </h2>
        <p class="w-full">
            Complete this form and discuss with at least one other member from your Threat Assessment Team for all threats. Use this form to help determine the need for a Full Team Threat Assessment.
        </p>
    </div>

    <div class="h-full w-full overflow-y-auto flex flex-col items-start justify-start gap-4">
        <ol class="flex items-center w-full">
            <li *ngFor="let step of stepsConfig" class="flex w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-100 after:border-4 after:inline-block">
                <button 
                    [attr.data-tooltip-target]="step.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === step.id,
                        'bg-orange-100': currentStep !== step.id && currentAssessScreen?.[step.completionProperty] === 1,
                        'bg-gray-100': currentStep !== step.id && currentAssessScreen?.[step.completionProperty] !== 1,
                        'cursor-not-allowed': step.nextStepDependency && currentAssessScreen?.[step.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(step.id)"
                    [disabled]="step.nextStepDependency && currentAssessScreen?.[step.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileUser" [ngClass]="{
                        'text-white': currentStep === step.id,
                        'text-nside-orange-400': currentStep !== step.id && currentAssessScreen?.[step.completionProperty] === 1,
                        'text-gray-text': currentStep !== step.id && currentAssessScreen?.[step.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="step.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[step.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
            <li class="flex items-center">
                <button 
                    [attr.data-tooltip-target]="finalStepConfig.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === finalStepConfig.id,
                        'bg-orange-100': currentStep !== finalStepConfig.id && currentAssessScreen?.[finalStepConfig.completionProperty] === 1,
                        'bg-gray-100': currentStep !== finalStepConfig.id && currentAssessScreen?.[finalStepConfig.completionProperty] !== 1,
                        'cursor-not-allowed': finalStepConfig.nextStepDependency && currentAssessScreen?.[finalStepConfig.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(finalStepConfig.id)"
                    [disabled]="currentAssessScreen?.[finalStepConfig.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileCheck" [ngClass]="{
                        'text-white': currentStep === finalStepConfig.id,
                        'text-nside-orange-400': currentStep !== finalStepConfig.id && currentAssessScreen?.[finalStepConfig.completionProperty] === 1,
                        'text-gray-text': currentStep !== finalStepConfig.id && currentAssessScreen?.[finalStepConfig.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="finalStepConfig.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[finalStepConfig.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
        </ol>
        
        <div class="w-full flex flex-col items-center justify-center overflow-y-auto gap-2">
            <assessment-situation 
                *ngIf="this.currentStep===1 && this.currentAssessScreen"
                [assessScreenData]="this.currentAssessScreen" 
                (onSaveSection1)="handleUpdateAssessScreen($event, 1)"
                class="w-full h-full overflow-y-auto" 
            ></assessment-situation>
            <evaluation-additional-info 
                *ngIf="this.currentStep===2"
                [assessScreenData]="this.currentAssessScreen" 
                (onSaveSection2)="handleUpdateAssessScreen($event, 2)"
                class="w-full h-full overflow-y-auto"
            ></evaluation-additional-info>
            <required-assessments 
                *ngIf="this.currentStep===3"
                [assessScreenData]="this.currentAssessScreen" 
                (onSaveSection3)="handleUpdateAssessScreen($event, 3)"
                class="w-full h-full overflow-y-auto"
            ></required-assessments>
            <official-signature
                *ngIf="this.currentStep===4"
                [assessScreenData]="this.currentAssessScreen" 
                (onSaveSection4)="handleUpdateAssessScreen($event, 4)"
                class="w-full h-full overflow-y-auto"
            ></official-signature>
            <evaluation-submission 
                *ngIf="this.currentStep===5"
                (onSaveSection5)="handleUpdateAssessScreen($event, 5)"
                class="w-full h-full overflow-y-auto"
            ></evaluation-submission>
        </div>
    </div>
</div>

<student-info
    *ngIf="this.showStudentInfo && this.studentSSID"
    [studentData]="this.studentInfo"
    (onClose)="handleCloseModal('student info')"
></student-info>

<popup-message 
    [type]="messageModal"
    (close)="resetMessageModal()"
    [message]="popupMessage"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>